import {createWebHistory, createWebHashHistory, createMemoryHistory, createRouter} from "vue-router";
import {defineAsyncComponent} from 'vue'

const ErrorComponent = {template: '<b>ERROR</b>'}

import LoadingComponent from "@/components/Pages/Configurator/LoadingComponent.vue";

const delay = 100;
const timeout = 3000;

import store from '@/store';

const ConfiguratorRoutes = [
    {
        path: "/produkt-waehlen",
        title: "Produkte wählen",
        icon: "box",
        action: "set-products",
        setter: "ChooseProducts/setChooseProducts",
        name: "ChooseProducts",
        file: 'Pages/Configurator/ChooseProducts.vue'
    },
    {
        path: "/dateneingabe",
        title: "Dateneingabe",
        icon: "paper",
        action: "set-order-data",
        setter: "OrderData/setOrderData",
        name: "OrderData",
        file: "Pages/Configurator/OrderData.vue",
    },
    {
        path: "/unterschrift",
        title: "Unterschrift",
        action: "set-signature",
        setter: "Signature/setSignature",
        icon: "pen",
        name: "Signature",
        file: "Pages/Configurator/Signature.vue"
    },
    {
        path: "/fertig",
        title: "Fertig",
        icon: "check",
        name: "Success",
        file: "Pages/Configurator/Success.vue"
    }
]

let RootRoutes = [
    {
        path: "/:catchAll(.*)",
        name: "404",
        file: "Pages/PageNotFound.vue"
    },
    {
        path: "/contact",
        name: "Contact",
        file: "Pages/Contact.vue"
    }
];

let RoutesCollection = {
    RootRoutes,
    ConfiguratorRoutes
}

const defineComponent = file => {

    return defineAsyncComponent({
        loader: () => import(/* webpackChunkName: "[request]", webpackPrefetch: true */`@/components/${file}`),
        delay: delay,
        timeout: timeout,
        errorComponent: ErrorComponent,
        loadingComponent: LoadingComponent
    })
}

for (const [key, routes] of Object.entries(RoutesCollection)) {
    routes.forEach((cRoute, index) => {
        RoutesCollection[key][index].component = defineComponent(cRoute.file);
    });
}

const Configurator = defineAsyncComponent({
    loader: () => import(/*webpackChunkName: 'Configurator', webpackPrefetch: true */'@/components/Pages/Configurator.vue'),
    delay: delay,
    timeout: timeout,
    errorComponent: ErrorComponent,
    loadingComponent: LoadingComponent
})

const routes = [
    {
        path: "/",
        name: "Home",
        redirect: {name: 'ChooseProducts'}
    },
    ...RootRoutes,
    {
        path: "/konfigurator",
        name: "Configurator",
        component: Configurator,
        meta: {
            layout: 'LayoutConfigurator'
        },
        children: [
            ...ConfiguratorRoutes,
        ]
    }

];

const router = createRouter({
    //history: createWebHistory(),
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    let nextStep = to.name;
    let nextStepIndex = ConfiguratorRoutes.findIndex(route => route.name === nextStep);




    let orderId = store.getters['OrderId/getOrderId'];
    console.log('orderId', orderId, nextStepIndex, ConfiguratorRoutes[nextStepIndex])
    if (orderId) {

        if ([1,0].includes(nextStepIndex)) {
            next({
                path: ConfiguratorRoutes[2].path
            })

        } else {
            next()
        }

        return;
    } else if (nextStepIndex != -1 && ConfiguratorRoutes[0].name != nextStep) {


        let lastStep = store.getters['Step/getStep'];
        let lastStepIndex = ConfiguratorRoutes.findIndex(route => route.name === lastStep);
        if (lastStep) {
            if (nextStepIndex > lastStepIndex) {

                let lastStepRoute = ConfiguratorRoutes.find(route => route.name === lastStep);

                next({
                    path: lastStepRoute.path
                })
            } else {
                next()
            }
        } else {
            next({
                path: ConfiguratorRoutes[0].path
            })
        }
    } else {
        next();
    }
})


export default router;
